// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"2286e95e96bccb14b908","655":"d224546ba480cee77896"}[chunkId] + ".js";
};